import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useState } from 'react';
import { Container, Image, Nav, NavDropdown } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { LoginInfo } from '../App';
import { useTranslation } from "react-i18next";
import SettingPopup from './SettingPopup';

const Home = () => {
    const location = useLocation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const {t,i18n} = useTranslation()
    const [showSetting,setShowSetting] = useState(false)
    function changeLanguage(lang){
        let s = localStorage
        s.removeItem("language")
        s.setItem("language",lang)
        i18n.changeLanguage(lang)
    }
    return (
        <div>
            {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        <div id="menu" style={{display:"none",transition:"0.5s",position:"fixed",left:"0",top:"0",width:"200px",height:"100%",zIndex:9999,color:"#FFFFFF",fontSize:"1.2em",backgroundColor:"#555555",overflow:"auto"}}>
            <ul style={{listStyleType:"none",padding:"30px 30px 0 30px"}}>
                <li onClick={() => {
                    let menu = document.getElementById("menu")
                    if(menu.style.display === "block"){
                        menu.style.display = "none"
                    } else {
                        menu.style.display = "block"
                    }
                }} style={{cursor:"pointer",paddingBottom:"1em"}}><Icon.List style={{fontSize:"1.5em",cursor:"pointer",border:"1px solid #FFFFFF"}} /> <img src='/img/logo_new_category.png' height={18} /></li>
                <li className='mb-3'>
                    <NavDropdown style={{marginTop:"4px",display:"block"}} title={(
                        <Icon.Globe style={{fontSize:"26px"}} />
                    )} id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => changeLanguage("ja")}>日本語</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("en")}>English</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("zhtw")}>中文(繁體)</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("zhCN")}>中文(简体)</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("ko")}>한국어</NavDropdown.Item>
                        {/*<NavDropdown.Item onClick={() => changeLanguage("zh-TW")}>中文(繁體)</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("zh-CN")}>中文(简体)</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLanguage("ko")}>한국어</NavDropdown.Item>*/}
                    </NavDropdown>
                </li>
                <LinkContainer to={"/about"} style={{padding:"0.5em 0",cursor:"pointer"}} ><li>{t("category.information")}</li></LinkContainer>
                <li style={{listStyle:"none"}}><LinkContainer to={"/legal"} onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})} style={{cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Stars style={{color:"orange"}} /> プレミアム</li></LinkContainer></li>
                <hr />
                <LinkContainer to={"/"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.HouseDoor /> {t("category.home")}</li></LinkContainer>
                <LinkContainer to={"/upload/image/generate"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Image /> {t("common.AIGeneration")}</li></LinkContainer>
                <LinkContainer to={"/search/*/1"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Search /> {t("category.search")}</li></LinkContainer>
                <LinkContainer to={"/tag/*/1"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Tags /> {t("category.tag")}</li></LinkContainer>
                <LinkContainer to={"/random"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Lightbulb /> {t("category.discover")}</li></LinkContainer>
                <LinkContainer to={"/search_characters"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Person /> キャラクター</li></LinkContainer>
                <LinkContainer to={"/search_users"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Person /> クリエイター</li></LinkContainer>
                <LinkContainer to={"/ranking/illustration/general/1day/s_all/1"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><RIcon.FaCrown /> {t("category.ranking")}</li></LinkContainer>
                <LinkContainer to={"/odai"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Pencil /> {t("category.odai")}</li></LinkContainer>
                <LinkContainer to={"/new"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.Lightbulb /> {t("category.new")}</li></LinkContainer>
                <LinkContainer to={"/terms"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.CardText /> {t("category.terms")}</li></LinkContainer>
                <LinkContainer to={"/guideline"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.CardText /> {t("common.guideline")}</li></LinkContainer>
                {false ? (<a href={"https://forms.gle/xiYfFU8FAwWkRFVF8"} style={{paddingBottom:"0.5em",cursor:"pointer",textDecoration:"none",color:"#FFFFFF"}}><li><Icon.InfoCircle /> {t("category.contact")}</li></a>) : ""}
            </ul>
            <hr />
            <ul style={{listStyleType:"none",padding:"0 30px"}}>
                {/*[
                    {name:t("category.mypage"),to:"/user/"+loginInfo.userId,icon:<Icon.Person />},
                    {name:t("category.manage"),to:"/manage",icon:<Icon.Images />},
                    {name:t("category.favorite"),to:"/favorite",icon:<Icon.HandThumbsUp />},
                    {name:t("category.stampManage"),to:"/stampManage",icon:<RIcon.FaStamp />},
                    {name:t("category.generatedHistory"),to:"/generatedHistory/image",icon:<RIcon.FaHistory />},
                ].map((d,i) => {
                    return <LinkContainer to={d.to} style={{paddingBottom:"0.5em",cursor:"pointer",display:loginInfo.length === undefined ? "block" : "none"}} key={i}><li>{d.icon} {d.name}</li></LinkContainer>
                })*/}
                <li 
                style={{cursor:"pointer"}}
                onClick={() => {
                    setShowSetting(true)
                    let menu = document.getElementById("menu")
                    if(menu.style.display === "block"){
                        menu.style.display = "none"
                    } else {
                        menu.style.display = "block"
                    }
                }}><Icon.GearWide /> {t("category.setting")}</li>
                <li className='text-center'>
                    <Link to={"https://lin.ee/9JVODFH"}  target='_blank' style={{fontSize:"28px",textDecoration:"none",color:"white"}}><Icon.Line /></Link>
                    &nbsp;&nbsp;
                    <Link to={"//x.com/ourt_ai"} target='_blank' style={{fontSize:"28px",color:"white",textDecoration:"none"}}>𝕏</Link>
                    &nbsp;&nbsp;
                    <Link to={"//discord.gg/DTsR7gnf6x"} target='_blank' style={{fontSize:"28px",color:"white"}}><Icon.Discord /></Link>
                    &nbsp;&nbsp;
                    <Link to={"//sns.ourt-ai.work"} target='_blank' style={{fontSize:"30px"}}><Image src="/img/misskey.png" width="30px" /></Link>
                </li>
                <LinkContainer to={"/siteManage"} style={{paddingTop:"0.5em",cursor:"pointer",display:loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") ? "block" : "none"}} ><li>サイト管理</li></LinkContainer>
            </ul>
        </div>
        </div>
    )
    const tmp = <Nav.Item><LinkContainer to={"/community"}><Nav.Link active={location.pathname.indexOf("/community") !== -1}>みんなの近況</Nav.Link></LinkContainer></Nav.Item>
}

export default Home;
